import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CertificationReportForm from '../../../../../shared/Cis/CertificationReports/Form/CertificationReportForm';
import {
  createIpmaCisCreator,
  loadIpmaCisDetailsCreator,
  removeIpmaCisDetailsCreator,
  updateIpmaCisCreator,
} from '../../../../../store/actionsCreators';
import reducer, { defaultState, setInitialStateCreator, updateFieldCreator } from './reducer';

const IpmaCertificationReportForm = ({
  appType,
  type,
  reports,
  loadReportDetails,
  id,
  createReport,
  updateReport,
  userPermissions,
  removeReportDetails,
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <CertificationReportForm
      appType={appType}
      type={type}
      reports={reports}
      loadReportDetails={loadReportDetails}
      createReport={createReport}
      updateReport={updateReport}
      id={id}
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      setInitialStateCreator={setInitialStateCreator}
      userPermissions={userPermissions}
      removeReportDetails={removeReportDetails}
    />
  );
};

IpmaCertificationReportForm.propTypes = {
  appType: PropTypes.string.isRequired,
  certificationBody: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    initials: PropTypes.string,
    sameAsMaContactData: PropTypes.bool,
    country: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    cbHeadName: PropTypes.string,
    cbHeadEmail: PropTypes.string,
    cbHeadTelephone: PropTypes.string,
    address: PropTypes.shape({
      id: PropTypes.number,
    }),
    lcAgreementSignedAt: PropTypes.string,
    lcValidationSignedAt: PropTypes.string,
    deltaAgreementSignedAt: PropTypes.string,
    iso9001AccreditationSignedAt: PropTypes.string,
    iso17024AccreditationSignedAt: PropTypes.string,
    cctAgreementSignedAt: PropTypes.string,
    memberAssociation: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      initials: PropTypes.string,
      photo: PropTypes.string,
    }),
    levels: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        domains: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
          }),
        ),
      }),
    ),
  }),
  status: PropTypes.string,
  type: PropTypes.string,
  createReport: PropTypes.func.isRequired,
  updateReport: PropTypes.func.isRequired,
  loadReportDetails: PropTypes.func.isRequired,
  id: PropTypes.number,
};

IpmaCertificationReportForm.defaultProps = {
  reports: {},
  type: 'ipma',
  id: 0,
};

const mapStateToProps = ({ user, ipma }) => ({
  appType: user.appType,
  reports: ipma.cis.reports.details,
  id: ipma.cis.reports.profile?.id ?? 0,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  createReport: (payload, history) => dispatch(createIpmaCisCreator('reports', payload, history)),
  updateReport: (id, payload, history) =>
    dispatch(updateIpmaCisCreator(id, 'reports', payload, history)),
  loadReportDetails: (payload, history) =>
    dispatch(loadIpmaCisDetailsCreator('reports', payload, history)),
  removeReportDetails: () => dispatch(removeIpmaCisDetailsCreator('reports')),
});

export default connect(mapStateToProps, mapDispatchToProps)(IpmaCertificationReportForm);
